import MessageApi from '../../../../api/inbox/message';

export default {
  async translateMessage(_, { conversationId, messageId, targetLanguage }) {
    try {
      const response = await MessageApi.translateMessage(
        conversationId,
        messageId,
        targetLanguage
      );
      return { success: true, data: response.data };
    } catch (error) {
      const errorData = error.response?.data || {};
      return {
        success: false,
        error: errorData.error || 'Translation failed',
        retryable: errorData.retryable || false,
        errorType: errorData.error_type,
      };
    }
  },
  async previewTranslation(_, { conversationId, content, targetLanguage }) {
    try {
      const response = await MessageApi.previewTranslation(
        conversationId,
        content,
        targetLanguage
      );
      return { success: true, data: response.data };
    } catch (error) {
      const errorData = error.response?.data || {};
      return {
        success: false,
        error: errorData.error || 'Translation failed',
        retryable: errorData.retryable || false,
      };
    }
  },
};
